import { CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import taskActivityServices from '../taskActivityServices';

import ActivityTimeline from './ActivityTimeline';
import { Forum, PinDrop } from '@mui/icons-material';

function TaskActivityList({taskId = 0}) {
    const [activityList,setActivityList] = useState(null);
    const [loading,setLoadingStatus] = useState(false);

    const getActivityList = () =>{
        setLoadingStatus(true);
        taskActivityServices.getByTaskId(taskId).then(res=>{
            setActivityList(res.data);
            console.log(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getAllActivityList = () =>{
        setLoadingStatus(true);
        taskActivityServices.getList().then(res=>{
            setActivityList(res.data);
            console.log(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    
    useEffect(()=>{
        if(taskId === 0){
            getAllActivityList()
        } else {
            getActivityList();
        }
        
    },[taskId])


    const [filteredList,setFilteredList] = useState(null);

    const [activeFilter,setActiveFilter] = useState("remark_update");

    useEffect(() => {
        if (activityList) {
            // Step 1: Filter by Project (if ID is provided)
            let filtered = [...activityList];

            // Step 2: Apply Status/Priority Filters
            if (activeFilter === 'remark_update') {
                filtered = filtered.filter(activity => activity.activityType === "remark_update");
            } else if (activeFilter === 'location_punch') {
                filtered = filtered.filter(activity => activity.activityType === "location_punch");
            } else if (activeFilter === 'all') {
                filtered = filtered;
            } 

            setFilteredList(filtered);
        }
    }, [activityList, activeFilter]);
    

    return (
    <>
            <div className='row' >
                <div className='col-md-12'>
                    <ul className="nav nav-pills nav-fill">
                        <li className="nav-item">
                            <button 
                                onClick={()=>setActiveFilter("remark_update")} 
                                className={activeFilter === "remark_update" ? "nav-link active" : "nav-link"}
                            ><Forum/>Remarks</button>
                        </li>
                        <li className="nav-item">
                            <button 
                                onClick={()=>setActiveFilter("location_punch")} 
                                className={activeFilter === "location_punch" ? "nav-link active" : "nav-link"}
                            ><PinDrop/> Location Punch</button>
                        </li>
                        <li className="nav-item">
                            <button 
                                onClick={()=>setActiveFilter("all")} 
                                className={activeFilter === "all" ? "nav-link active" : "nav-link"}
                            > All</button>
                        </li>
                        
                    </ul>
                </div>
            </div>
            {loading && <div className='text-center p-5'><CircularProgress/></div>}
            {!loading && filteredList &&
                <ActivityTimeline data={filteredList} />
            }
    </>
    )
}

export default TaskActivityList